// TODO: use theme colors after new theme is developed
const colors = {
  menuTitle: '#a7b4bb',
  favoriteStar: '#F1C40F',
  background: '#303030',
  itemHover: '#282828'
};

export { colors };
